import { render, staticRenderFns } from "./JoinBanner.vue?vue&type=template&id=f3452a9e&scoped=true"
import script from "./JoinBanner.vue?vue&type=script&lang=ts"
export * from "./JoinBanner.vue?vue&type=script&lang=ts"
import style0 from "./JoinBanner.vue?vue&type=style&index=0&id=f3452a9e&prod&lang=scss"
import style1 from "./JoinBanner.vue?vue&type=style&index=1&id=f3452a9e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3452a9e",
  null
  
)

export default component.exports